module.exports = __webpack_public_path__ + "static/media/Adv_photo_01_240603.e7154547.webp";